import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Com0406CtlrOut } from 'app/core/models/api/com/com0406'
import { selectCom0406 } from 'app/core/services/com/com.service'

const slice = createSlice({
    name: 'bankingInfo',
    initialState: {} as Com0406CtlrOut,
    reducers: {
        clear: (state) => {
            return {} as Com0406CtlrOut
        },
        /**
         * 쓰나?
         * @param state
         * @param action
         * @returns
         */
        setBankingInfo: (state, action: PayloadAction<Com0406CtlrOut>) => {
            return action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(selectCom0406.matchFulfilled, (state, action) => {
            //API가 성공하면 가로채 넣는다.
            return { ...action.payload }
        })
    },
})

export const { clear, setBankingInfo } = slice.actions

export default slice.reducer
